/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EpaOperatorNotification } from './EpaOperatorNotification';
import {
    EpaOperatorNotificationFromJSON,
    EpaOperatorNotificationFromJSONTyped,
    EpaOperatorNotificationToJSON,
    EpaOperatorNotificationToJSONTyped,
} from './EpaOperatorNotification';

/**
 * Serializer for the EpaForm model.
 * @export
 * @interface EpaForm
 */
export interface EpaForm {
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    readonly id: string;
    /**
     * 
     * @type {EpaOperatorNotification}
     * @memberof EpaForm
     */
    operatorNotification: EpaOperatorNotification;
    /**
     * 
     * @type {boolean}
     * @memberof EpaForm
     */
    responsibleForEmission?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    epaId?: string;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    apiWellId?: string;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    facilityName?: string;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    address?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EpaForm
     */
    assertDemonstrableError?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    statementDemonstrableError?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EpaForm
     */
    affectedFacility?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof EpaForm
     */
    identifiedSource?: boolean | null;
    /**
     * 
     * @type {any}
     * @memberof EpaForm
     */
    investigationSteps?: any | null;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    alternateTestMethods?: string;
    /**
     * 
     * @type {Date}
     * @memberof EpaForm
     */
    investigationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    investigationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    investigationTimezone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EpaForm
     */
    certifiesAllInvestigationsDone?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    sourceOfEmission?: string;
    /**
     * 
     * @type {any}
     * @memberof EpaForm
     */
    subjectToRegulation?: any | null;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    citationOfRegulation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EpaForm
     */
    eventStillOngoing?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof EpaForm
     */
    eventEndDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof EpaForm
     */
    isEstimate?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    eventEndTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    eventEndTimezone?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EpaForm
     */
    targetedEndDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EpaForm
     */
    planForEvent?: string;
    /**
     * 
     * @type {Date}
     * @memberof EpaForm
     */
    readonly createdAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EpaForm
     */
    readonly updatedAt: Date | null;
}

/**
 * Check if a given object implements the EpaForm interface.
 */
export function instanceOfEpaForm(value: object): value is EpaForm {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('operatorNotification' in (value as Record<string, any>)) && !('operator_notification' in (value as Record<string, any>))) || ((value as Record<string, any>)['operatorNotification'] === undefined && (value as Record<string, any>)['operator_notification'] === undefined)) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('updatedAt' in (value as Record<string, any>)) && !('updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedAt'] === undefined && (value as Record<string, any>)['updated_at'] === undefined)) return false;
    return true;
}

export function EpaFormFromJSON(json: any): EpaForm {
    return EpaFormFromJSONTyped(json, false);
}

export function EpaFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpaForm {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'operatorNotification': EpaOperatorNotificationFromJSON(json['operator_notification']),
        'responsibleForEmission': json['responsible_for_emission'] === undefined ? undefined : json['responsible_for_emission'] === null ? null : json['responsible_for_emission'],
        'epaId': json['epa_id'] == null ? undefined : json['epa_id'],
        'apiWellId': json['api_well_id'] == null ? undefined : json['api_well_id'],
        'facilityName': json['facility_name'] == null ? undefined : json['facility_name'],
        'address': json['address'] == null ? undefined : json['address'],
        'assertDemonstrableError': json['assert_demonstrable_error'] === undefined ? undefined : json['assert_demonstrable_error'] === null ? null : json['assert_demonstrable_error'],
        'statementDemonstrableError': json['statement_demonstrable_error'] == null ? undefined : json['statement_demonstrable_error'],
        'affectedFacility': json['affected_facility'] === undefined ? undefined : json['affected_facility'] === null ? null : json['affected_facility'],
        'identifiedSource': json['identified_source'] === undefined ? undefined : json['identified_source'] === null ? null : json['identified_source'],
        'investigationSteps': json['investigation_steps'] === undefined ? undefined : json['investigation_steps'] === null ? null : json['investigation_steps'],
        'alternateTestMethods': json['alternate_test_methods'] == null ? undefined : json['alternate_test_methods'],
        'investigationDate': json['investigation_date'] === undefined ? undefined : json['investigation_date'] === null ? null : (new Date(json['investigation_date'])),
        'investigationTime': json['investigation_time'] === undefined ? undefined : json['investigation_time'] === null ? null : json['investigation_time'],
        'investigationTimezone': json['investigation_timezone'] === undefined ? undefined : json['investigation_timezone'] === null ? null : json['investigation_timezone'],
        'certifiesAllInvestigationsDone': json['certifies_all_investigations_done'] === undefined ? undefined : json['certifies_all_investigations_done'] === null ? null : json['certifies_all_investigations_done'],
        'sourceOfEmission': json['source_of_emission'] == null ? undefined : json['source_of_emission'],
        'subjectToRegulation': json['subject_to_regulation'] === undefined ? undefined : json['subject_to_regulation'] === null ? null : json['subject_to_regulation'],
        'citationOfRegulation': json['citation_of_regulation'] == null ? undefined : json['citation_of_regulation'],
        'eventStillOngoing': json['event_still_ongoing'] === undefined ? undefined : json['event_still_ongoing'] === null ? null : json['event_still_ongoing'],
        'eventEndDate': json['event_end_date'] === undefined ? undefined : json['event_end_date'] === null ? null : (new Date(json['event_end_date'])),
        'isEstimate': json['is_estimate'] === undefined ? undefined : json['is_estimate'] === null ? null : json['is_estimate'],
        'eventEndTime': json['event_end_time'] === undefined ? undefined : json['event_end_time'] === null ? null : json['event_end_time'],
        'eventEndTimezone': json['event_end_timezone'] === undefined ? undefined : json['event_end_timezone'] === null ? null : json['event_end_timezone'],
        'targetedEndDate': json['targeted_end_date'] === undefined ? undefined : json['targeted_end_date'] === null ? null : (new Date(json['targeted_end_date'])),
        'planForEvent': json['plan_for_event'] == null ? undefined : json['plan_for_event'],
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
    };
}

export function EpaFormToJSON(json: any): EpaForm {
    return EpaFormToJSONTyped(json, false);
}

export function EpaFormToJSONTyped(value?: Omit<EpaForm, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operator_notification': EpaOperatorNotificationToJSON(value['operatorNotification']),
        'responsible_for_emission': value['responsibleForEmission'],
        'epa_id': value['epaId'],
        'api_well_id': value['apiWellId'],
        'facility_name': value['facilityName'],
        'address': value['address'],
        'assert_demonstrable_error': value['assertDemonstrableError'],
        'statement_demonstrable_error': value['statementDemonstrableError'],
        'affected_facility': value['affectedFacility'],
        'identified_source': value['identifiedSource'],
        'investigation_steps': value['investigationSteps'],
        'alternate_test_methods': value['alternateTestMethods'],
        'investigation_date': value['investigationDate'] == null ? value['investigationDate'] : value['investigationDate'].toISOString().substring(0,10),
        'investigation_time': value['investigationTime'],
        'investigation_timezone': value['investigationTimezone'],
        'certifies_all_investigations_done': value['certifiesAllInvestigationsDone'],
        'source_of_emission': value['sourceOfEmission'],
        'subject_to_regulation': value['subjectToRegulation'],
        'citation_of_regulation': value['citationOfRegulation'],
        'event_still_ongoing': value['eventStillOngoing'],
        'event_end_date': value['eventEndDate'] == null ? value['eventEndDate'] : value['eventEndDate'].toISOString().substring(0,10),
        'is_estimate': value['isEstimate'],
        'event_end_time': value['eventEndTime'],
        'event_end_timezone': value['eventEndTimezone'],
        'targeted_end_date': value['targetedEndDate'] == null ? value['targetedEndDate'] : value['targetedEndDate'].toISOString().substring(0,10),
        'plan_for_event': value['planForEvent'],
    };
}

